import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_ESTIMATES_REFRESH: createSagaAction('JOB_SITE_ESTIMATES_REFRESH'),

  JOB_SITE_ESTIMATE_CREATE: createSagaAction('JOB_SITE_ESTIMATE_CREATE'),
  JOB_SITE_ESTIMATE_UPDATE: createSagaAction('JOB_SITE_ESTIMATE_UPDATE'),
  JOB_SITE_ESTIMATE_DELETE: createSagaAction('JOB_SITE_ESTIMATE_DELETE'),

  GET_ESTIMATE_SECTIONS: createSagaAction('GET_ESTIMATE_SECTIONS'),
  GET_ESTIMATE_ITEMS: createSagaAction('GET_ESTIMATE_ITEMS'),

  UPLOAD_ESTIMATE_ATTACHMENT: createSagaAction('UPLOAD_ESTIMATE_ATTACHMENT'),
  GET_ESTIMATE_ATTACHMENTS: createSagaAction('GET_ESTIMATE_ATTACHMENTS'),
  UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_ESTIMATE_ATTACHMENT: createSagaAction('DELETE_ESTIMATE_ATTACHMENT'),
  RESET_ESTIMATE_ITEMS: createSagaAction('RESET_ESTIMATE_ITEMS')
}

// Action Creators
export const actions = {
  jobSiteEstimatesRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_ESTIMATES_REFRESH.ACTION,
    jobId,
    next
  }),

  createJobSiteEstimate: ({ jobId, content, estimateSections, userId }) => ({
    type: constants.JOB_SITE_ESTIMATE_CREATE.ACTION,
    jobId,
    content,
    estimateSections,
    userId
  }),

  updateJobSiteEstimate: ({ jobId, estimateId, content, estimateSections, userId }) => ({
    type: constants.JOB_SITE_ESTIMATE_UPDATE.ACTION,
    jobId,
    estimateId,
    content,
    estimateSections,
    userId
  }),

  deleteJobSiteEstimate: ({ estimateId, jobId }) => ({
    type: constants.JOB_SITE_ESTIMATE_DELETE.ACTION,
    jobId,
    estimateId
  }),

  getEstimateSections: estimateId => ({
    type: constants.GET_ESTIMATE_SECTIONS.ACTION,
    estimateId
  }),

  getEstimateItems: estimateId => ({
    type: constants.GET_ESTIMATE_ITEMS.ACTION,
    estimateId
  }),

  // Attachment actions
  uploadAttachmentEstimate: ({ formData, estimateId }) => ({
    type: constants.UPLOAD_ESTIMATE_ATTACHMENT.ACTION,
    formData,
    estimateId
  }),

  getAttachmentsEstimate: ({ estimateId }) => ({
    type: constants.GET_ESTIMATE_ATTACHMENTS.ACTION,
    estimateId
  }),

  updateAttachmentDescriptionEstimate: ({ attachmentId, estimateId, description, userId }) => ({
    type: constants.UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    estimateId,
    description,
    userId
  }),

  deleteAttachmentEstimate: ({ attachmentId, estimateId }) => ({
    type: constants.DELETE_ESTIMATE_ATTACHMENT.ACTION,
    attachmentId,
    estimateId
  }),

  resetEstimateItems: () => ({
    type: constants.RESET_ESTIMATE_ITEMS.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_ESTIMATES_REFRESH.ACTION:
      return { ...state, loading: true }
    case constants.JOB_SITE_ESTIMATES_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteEstimates: action.payload,
        loading: false
      }
    case constants.JOB_SITE_ESTIMATES_REFRESH.FAILED:
      return {
        error: action.message,
        loading: false
      }
    case constants.JOB_SITE_ESTIMATE_CREATE.SUCCESS:
      return {
        loading: false,
        ...state
      }
    case constants.JOB_SITE_ESTIMATE_UPDATE.SUCCESS:
      return {
        loading: false,
        ...state
      }
    case constants.JOB_SITE_ESTIMATE_DELETE.SUCCESS:
      return {
        loading: false,
        ...state
      }
    case constants.GET_ESTIMATE_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ESTIMATE_SECTIONS.SUCCESS:
      return {
        loading: false,
        ...state,
        jobSiteEstimateSections: action.payload
      }
    case constants.GET_ESTIMATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ESTIMATE_ITEMS.SUCCESS:
      return {
        ...state,
        loading: false,
        jobSiteEstimateItems: action.payload.data
      }

    case constants.UPLOAD_ESTIMATE_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_ESTIMATE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false,
        loading: false
      }

    case constants.GET_ESTIMATE_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_ESTIMATE_ATTACHMENTS.SUCCESS:
      return {
        loading: false,
        ...state,
        jobEstimateAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        loading: false,
        ...state
      }

    case constants.DELETE_ESTIMATE_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_ESTIMATE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false,
        loading: false
      }

    case constants.RESET_ESTIMATE_ITEMS.ACTION:
      return {
        ...state,
        loading: false,
        jobSiteEstimateItems: null
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteEstimateActions.js